<h2>Health at a Glance</h2>
<p>As of: {{asOf() | date: 'MM/dd/yyyy, HH:mm:ss'}}, 
    <br/>
   {{totalIntegrations()}} Integrations Ran
</p>
<div class="status-container">
    <div class="pie-chart">

      <div class="chart-container">
         <canvas baseChart
            [type]="'pie'"
            [data]="chartData()"
            [options]="pieChartOptions"
            [legend]="pieChartLegend">
         </canvas>
      </div>

    </div>
    <div class="status-info">
       <h3>Status</h3>
       @for (status of statuses(); track status) {
         <div>
            <span class="status-indicator" (click)="filter(status?.status?.toString())">
               <span class="color-indicator" [style.background-color]="status?.color"></span>
               <span>{{status?.status}} - {{status?.count}}</span>
            </span>
         </div>
      }
    </div>
</div>
